module.exports = __webpack_public_path__ + "img/vippack_dg.3ccb706a.png";